const clientAssets = {
  coffeebeans: {
    name: 'Rewards App',
    companyName: 'CoffeeBeans',
    domain: 'coffeebeans.io',
    logo: 'https://coffeebeans.io/images/home/cbLogoNew.svg',
    contact: [
      {
        name: 'Kevin Jacob',
        email: 'kevin@coffeebeans.io',
        phone: '+91-9876543225'
      },
      {
        name: 'Priyanka Raymund',
        email: 'priyanka@coffeebeans.io',
        phone: '+91-9876543226'
      }
    ]
  },
  pcc: {
    name: 'PCC Rewards',
    companyName: 'Park Controls',
    domain: 'parkcontrols.com',
    logo: 'https://www.parkcontrols.com/image/logo/PCC%20Logo%20(No%20Background)(9.12.24)-01.png',
    contact: [
      {
        name: 'Priyanka Raymund',
        email: 'priyanka@coffeebeans.io',
        phone: '+91-9876543226'
      }
    ]
  }
};

export const getClientAssets = tenantCode => clientAssets[tenantCode] || clientAssets.coffeebeans;

export default clientAssets;
